import React from "react";
import DepotTable from "./DepotTable";

const DepotViewContent = () => {
  return (
    <div className="">
      <DepotTable />
    </div>
  );
};

export default DepotViewContent;
